export const LOCAL_ENVS = [/^localhost/, /^core\.dev/, /raisin-dev/, /^bk-/, /bk\./, /staging-/];
export const REGION = {
    GBR: 'GBR',
    DEU: 'DEU',
    USA: 'USA',
};
export const ENVIRONMENT_DOMAINS = {
    local: 'dev-',
    development: 'dev-',
    staging: 'staging-',
    onboarding: 'onboarding-',
    production: '',
};
export const KNOWN_COUNTRY_CODE_TOP_LEVEL_DOMAINS = ['co.uk'];
//# sourceMappingURL=domain.js.map